import { CaptchaDialog } from '~/modal/index'
import { modal_ajax_error_handler } from '~/modal/_ajax_error_handler';

export function reduceReducers(...reducers) {
  // This takes 2 reducers and reduces them into a single reducer (from r to l).
  // We are using this to merge photos and posts reducers, for example. Another
  // way to look at it is extending a reducer. We can extend the post reducer with
  // additional actions from the photos reducer.
  // Example: reducer_A = reduceReducers(reducer_A, reducer_B);
  return (previous, current) =>
    reducers.reduce(
      (p, r) => r(p, current),
      previous
    );
}

let guidIndex = 0;
const guidPrefix = Math.floor(Math.random() * 2147483647).toString(16);
export function guid(){
  return `${guidPrefix}-${guidIndex++}`
}

export function eventHasPassed() {
  return window.event_has_passed? true: false;
}

export function isPremium() {
  return window.is_premium? true: false;
}

export function isCard() {
  return window.is_card? true: false;
}

export function isCancelled() {
  return window.evite_event.status === 'cancelled';
}

export function canRSVP() {
  return !isCard() && !eventHasPassed() && !isCancelled();
}

export function isPreview() {
  return window.is_preview? true: false;
}

export function isMobile() {
  return window.is_mobile_site ? true: false;
}

export function isMobileDevice() {
  return window.is_mobile? true: false;
}

const { navigator } = window;
const { userAgent } = navigator;

export function isIpad() {
  return Boolean(userAgent.match(/iPad/i));
}

export function isIphone() {
  return Boolean(userAgent.match(/iPhone/i));
}

export function isFireFox() {
  return Boolean(userAgent.match(/firefox/i));
}

export function isAndroid() {
  return Boolean(userAgent.match(/android/i));
}

export function isWindows() {
  return (window.navigator.platform || '').match(/Win/i);
}


export function isHost() {
  return window.evite_event.is_host_viewing? true: false;
}

export function isGuest() {
  return Boolean(window.guest_id);
}

export function showKnot(storeName='template') {
  return Boolean(window.KNOT_EVENT_TYPES.indexOf(evite.store.get(`${storeName}.event_type`)) !== -1);
}
export function showBump(storeName='template') {
  return Boolean(window.BUMP_EVENT_TYPES.indexOf(evite.store.get(`${storeName}.event_type`)) !== -1);
}

export function getGiftingType(storeName) {
  const show_knot = window.KNOT_EVENT_TYPES ? showKnot(storeName) : window.show_knot;
  const show_bump = window.BUMP_EVENT_TYPES ? showBump(storeName) : window.show_bump;
  const giftType = show_knot ? 'knot' : show_bump ? 'bump' : 'amazon';

  return giftType;
}

export function hasRsvpd() {
  return window.has_rsvpd? true: false;
}

export function canComment() {
  return isGuest() && (hasRsvpd() || eventHasPassed());
}

export function canPostPhotos() {
  return isGuest() && (hasRsvpd() || eventHasPassed());
}

export function isBreakPoint(name) {
  const $body = $('body');
  const hasOverflow = /\boverflow\b/i.test($body.attr('style') || '');
  const originalOverflow = hasOverflow? $body.css('overflow'): '';
  $body.css('overflow', 'hidden');
  const viewWidth = $body.width();

  $('body').css('overflow', originalOverflow);

  const tolerance = 0.001;
  const smallBreakpointLimit = 500;
  const mediumBreakpointLimit = 768;
  const desktopBreakpointLimit = 1279;

  switch(name) {
    case 'small-and-down':
      return viewWidth <= (smallBreakpointLimit - tolerance);
    case 'medium-and-down':
      return viewWidth <= (mediumBreakpointLimit - tolerance);
    case 'medium-and-up':
      return viewWidth > smallBreakpointLimit;
    case 'large-and-up':
      return viewWidth > mediumBreakpointLimit;
    case 'desktop':
      return viewWidth < desktopBreakpointLimit;
    default:
      if (console && console.error) {
        console.error(`Unknown breakpoint "${name}"`);
      }
      return false;
  }
}

export function canDeleteEventItem(itemUserId) {
  return isHost() || window.user_id === itemUserId;
}

export function canEditEventItem(itemUserId) {
  return window.user_id === itemUserId;
}

export function eventTabUrlPath(urlPart, urlHash = "") {
  const qs = window.location.search;
  return `/event/${window.evite_event.id}/${urlPart}${qs}${urlHash}`;
}

export function handleCaptcha(xhr, status, data, callback) {
  if (xhr && xhr.status === 412) {
    let response = JSON.parse(xhr.responseText);
    new CaptchaDialog({
      challenge: response,
      onSubmit: function (captcha) {
        captcha['name'] = void 0;
        captcha = JSON.stringify(captcha);
        callback(captcha);
      }
    }).show();
  }
  else {
    renderAjaxErrorModal(xhr, status, data);
    if (callback) {
      callback('');
    }
  }
}

export function renderAjaxErrorModal(xhr, status, data) {
  const hasStatus = xhr && xhr.status;
  const isServerError = xhr && xhr.status >= 500 && xhr.status < 600;

  if (hasStatus && (isMobile() || isServerError)) {
    let message = 'Sorry, an error has occurred';
    let responseTextMessage;

    try {
      responseTextMessage = JSON.parse(xhr.responseText).message;
    } catch (error) {
      responseTextMessage = xhr.responseText;
    }

    if (isServerError) {
      let consoleTitle = typeof data == 'string'? data: 'Internal Server Error';
      if (responseTextMessage && console && console.error) {
        console.error(`${consoleTitle}:\n\n${responseTextMessage}\n`);
      }
      message = 'Sorry, an internal server error has occurred';
    }
    else if (responseTextMessage) {
      message = responseTextMessage;
    }

    alert(message);
  } else {
    modal_ajax_error_handler(xhr, status, data);
  }
}

export function b64toBlob(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  const ab = new ArrayBuffer(byteString.length);
  let ia = new Uint8Array(ab);
  for(let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });
  return blob;
}

export function pluralize(label, count) {
  label = count === 1? label: `${label}s`;
  return `${count} ${label}`;
}

export function formatMoney(amount) {
  return amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
}

export function indexes(source, find) {
  const result = [];
  for (let i = 0; i < source.length; ++i) {
    if (source.substring(i, i + find.length) === find) {
      result.push(i);
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/utils.es6